var _style, _path, _rect, _defs, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcci(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 43.35",
    style: {
      enableBackground: "new 0 0 120 43.35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#010202;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#EF7C48;}\r\n\t.st2{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.26,10.51l1.42,17.36h-3.54C49.13,25.04,50.43,12.4,51.26,10.51L51.26,10.51z M102.05,43.35h10.51V25.39 l6.5-0.35v-8.03h-4.84c-1.42,0-1.18,0-1.65-0.35V8.98V8.62H120V0h-17.95V43.35z M87.17,43.35h10.51V0H87.17V43.35z M67.91,43.35 h10.51V8.74l6.26-0.12V0H61.54v8.62l6.38,0.24V43.35z M37.68,43.35h10.87l0.71-7.44c0.35-1.18,3.19-0.59,3.78-0.35 c0.24,0.47,0-0.47,0.24,0.71c0.24,0.71,0.12,0.59,0.12,1.18l0.24,5.91h10.75L58.35,0H43.11L37.68,43.35z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st1",
    width: 32.95,
    height: 43.35
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 32.95,
    height: 43.35
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M4.72,27.87l1.3,1.18c0.12-0.12,0.24-0.35,0.24-0.24l10.16-15l7.56,11.34c0.94,1.42,1.77,3.07,2.72,3.78 c0.59-0.35,0.71-0.35,1.3-0.71c-0.24-1.54-4.61-7.32-5.67-9.09c-0.94-1.65-1.89-2.95-2.95-4.49c-0.94-1.42-1.89-3.19-2.95-4.49 L4.72,27.87z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M4.61,21.38c0.47,0.35,1.06,0.71,1.54,0.94c1.18-0.83,7.8-11.93,9.45-14.17l0.83-0.83 c0.71,0.59,4.13,6.02,5.08,7.44c0.71,1.18,4.49,7.09,5.2,7.56c0.47-0.24,0.94-0.59,1.42-0.94L16.42,3.66 c-0.83,0.83-2.24,3.19-2.95,4.37C10.87,11.93,6.73,17.72,4.61,21.38L4.61,21.38z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M4.61,34.37l1.54,1.18c1.65-2.13,3.43-4.96,4.96-7.44l5.31-7.68c0.71,0.71,4.13,6.02,5.08,7.44 c1.54,2.36,3.43,5.67,5.2,7.68l1.42-1.06c-2.01-2.6-4.02-6.38-5.79-8.98l-5.91-8.74L7.56,30C6.61,31.42,5.55,33.19,4.61,34.37 L4.61,34.37z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcci);
export default __webpack_public_path__ + "static/media/ACCI.d641b015a636e7478ccb46bb2679838d.svg";
export { ForwardRef as ReactComponent };